import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  /** Prépare les dépendances utilisées pour décider si la navigation est autorisée. */
  constructor(private auth: AuthService, private router: Router) {}

  /** Autorise la navigation si la session possède les droits attendus. */
  canActivate(_route?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (this.auth.isLoggedIn()) {
      return of(true);
    }

    return this.auth.refresh().pipe(
      map(() => true),
      catchError(() => of(this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state?.url ?? '/' } })))
    );
  }
}
